<template>
  <main class="sa-content sa-aptlistbox">
    <div class="sa-card-large">
      <div class="sa-mob-header">
        <h5 class="sa-card-tit">My appointments</h5>
        <button class="sa-btn-back" @click="$router.go(-1)">
          <i class="icon-arrow-left"></i>
        </button>
      </div>
      <div class="sa-mob-cont">
        <div class="sa-row">
          <div class="sa-col-xs12 sa-col-sm12 sa-col-md4 sa-col-lg4 ">
            <div class="sa-card sa-card-gray sa-card-noshadow sa-h-xs sa-h-sm">
              <strong class="sa-d-block">Select Service</strong>
              <div class="sa-appoint-radio">
                <span>
                  <input type="radio" id="all" name="all" value="all" />
                  <label for="all">All</label>
                </span>

                <span>
                  <input type="radio" id="video" name="video" value="ST1" />
                  <label for="video">All Appointments</label>
                </span>
                <span>
                  <input
                    type="radio"
                    id="videoFollow"
                    name="video"
                    value="ST11"
                  />
                  <label for="videoFollow">All Appointments</label>
                </span>
              </div>
            </div>
            <div class="sa-form-group sa-h-md-up">
              <i class="icon-down-arrow sa-form-icon"></i>
              <select class="sa-form-control">
                <option value="all">
                  All
                </option>
                <option value="ST0">
                  All Appointments
                </option>
                <option value="ST1">
                  All Appointments
                </option>
              </select>
            </div>
            <div class="sa-card sa-card-gray sa-card-noshadow sa-noshadowm">
              <strong class="sa-d-block sa-h-xs sa-h-sm">Appointments</strong>
              <div class="sa-appoint-radio">
                <span @click="appointments = 'new-bookings'">
                  <input
                    type="radio"
                    id="upComingAppoint"
                    name="appointments"
                    value="3"
                    checked
                  />
                  <label for="upComingAppoint">New Bookings</label>
                </span>
                <span @click="appointments = 'completed'">
                  <input
                    type="radio"
                    id="compAppoint"
                    name="appointments"
                    value="4"
                  />
                  <label for="compAppoint"
                    >Completed
                    <dfn class="sa-h-xs sa-h-sm">Appointments</dfn></label
                  >
                </span>
                <span @click="appointments = 'cancelled'">
                  <input
                    type="radio"
                    id="canAppoint"
                    name="appointments"
                    value="5"
                  />
                  <label for="canAppoint"
                    >Cancelled
                    <dfn class="sa-h-xs sa-h-sm">Appointments</dfn></label
                  >
                </span>
                <span @click="appointments = 'noshow'">
                  <input
                    type="radio"
                    id="noshow"
                    name="appointments"
                    value="7"
                  />
                  <label for="noshow">No Show</label>
                </span>
              </div>
            </div>
          </div>
          <div class="sa-col-xs12 sa-col-sm8 sa-col-md8 sa-col-lg8">
            <template v-if="appointments === 'new-bookings'">
              <ul class="sa-card-list sa-new-appt-list">
                <li
                  v-for="item in 10"
                  :key="item"
                  @click="$router.push('/new-booking-details')"
                >
                  <AppointmentListCard />
                </li>
              </ul>
            </template>
            <template v-if="appointments === 'completed'">
              <ul class="sa-card-list sa-new-appt-list">
                <li
                  v-for="item in 10"
                  :key="item"
                  @click="$router.push('/completed-details')"
                >
                  <AppointmentListCard />
                </li>
              </ul>
            </template>
            <template v-if="appointments === 'cancelled'">
              <ul class="sa-card-list">
                <li>
                  <CancelledDetails />
                </li>
              </ul>
            </template>
            <template v-if="appointments === 'noshow'">
              <ul class="sa-card-list">
                <li>
                  <NoShow />
                </li>
              </ul>
            </template>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import AppointmentListCard from "../../components/nurse/AppointmentListCard.vue";
import CancelledDetails from "../../components/nurse/CancelledDetails.vue";
import NoShow from "../../components/nurse/NoShow.vue";
export default {
  components: { AppointmentListCard, CancelledDetails, NoShow },
  data() {
    return {
      appointments: "new-bookings",
    };
  },
};
</script>
<style></style>
